module.exports = __webpack_public_path__ + "static/media/add-plus-icon.0e3e08bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add-plus-icon.svg
// module id = 382
// module chunks = 35